"use client"
import {Box, Flex, Image, Title} from "@mantine/core";
import {Carousel} from "@mantine/carousel";
import {useMediaQuery} from "@mantine/hooks";
import Autoplay from 'embla-carousel-autoplay';
import {useEffect, useRef, useState} from "react";
import {Partners, searchPartners} from "src/entities/partners";
import {AttachmentPath} from "src/entities/attachments";
import {useTranslation} from "react-i18next";
import {Content} from "src/shared/helpers/content";

export const PartnersWidget = () => {
    const {i18n, t} = useTranslation()
    const locale = i18n.language
    const largeScreen = useMediaQuery("(max-width: 1200px)")
    const smallScreen = useMediaQuery("(max-width: 768px)")
    const autoplay = useRef(Autoplay({ delay: 2000 }));
    const [partners, setPartners] = useState<Partners[]>()
    const fetchPartners = async () => {
        const res = await searchPartners({
            filter: {
            },
            pageRequest: {limit: 100, page: 0},
            sorting: {sortBy: "ID", sortDirection: "DESC"},
        },false)
        if(res?.content && res?.content?.length > 4){
            setPartners([...(res?.content || []), ...(res?.content || [])])
        }else{
             setPartners(res?.content || [])
        }
    }
    useEffect(() => {
        fetchPartners()
    }, []);

    const content =( partners && partners?.length > 5 ) || !largeScreen ?
        <Carousel
            withControls={false}
            plugins={[autoplay.current]}
            onMouseEnter={autoplay.current.stop}
            onMouseLeave={autoplay.current.reset}
            slideGap={smallScreen ? 10 : 24}
            loop={true}
            align="start"
            slideSize={smallScreen ? "35%" : largeScreen ? "30%"  : "20%" }>
            {partners?.map((partner,index) => (
                <Carousel.Slide key={index}>
                    <Flex h={80} w="100%" justify="center" align="center" gap={10}>
                        {partner?.logo?.id &&
                            <img width={partner?.titleRu ? 60 : 180} height={partner?.titleRu ? 60 : 180} style={{objectFit: "contain"}} alt=""
                                        src={AttachmentPath.GetAttachmentUrl(partner.logo.id)}/>}
                        {partner?.titleRu ? <Title lh={1.2} fz={{base: 16, md: 20, lg: 28}} fw={900} c="#c4c4c4">
                            {Content.GetTitleByLanguage(partner, locale)}
                        </Title> : null}
                    </Flex>
                </Carousel.Slide>
            ))}
        </Carousel> :
        <Flex>
            {partners?.map((partner,index) => (
                <Flex key={index} h={80} w="100%" justify="center" align="center" gap={10}>
                    {partner?.logo?.id &&
                        <Image width={partner?.titleRu ? 60 : 180} height={partner?.titleRu ? 60 : 180} style={{objectFit: "contain"}} alt=""
                                                 src={AttachmentPath.GetAttachmentUrl(partner.logo.id)}/>}
                    {partner?.titleRu ? <Title fz={{base: 24, sm: 28}} fw={900} c="#c4c4c4">
                        {Content.GetTitleByLanguage(partner, locale)}
                    </Title> : null}
                </Flex>
            ))}
        </Flex>

    if(!partners?.length) return null
    return (
        <Flex mb={{base: 40, sm: 80}} direction="column">
            <Box mb={{base: 24, sm: 40}}>
                <Title  c="#5C5D61" fz={20} fw={600} ta="center">
                    {t('section.titles.partners')}
                </Title>
            </Box>
            {content}
        </Flex>
    )
}